import styled from 'styled-components';

export const RecordsUpdateStyle = styled.div`
  padding: 10px 30px;
  text-align: center;
`;

export const TitleText = styled.h2`
  margin: 20px;
  color: ${({ theme }) => theme.palette.primary.main};

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin: 10px 20px;
  }
`;
